export default __webpack_public_path__ + "static/Screenshot2-4dc0eeb9da5961597b652cbb92b63cdc.jpg";